import { CircularProgress, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';

import { useStyles } from './CircularProgress.styles';
import { CircularProgressProps } from './CircularProgress.types';

export const MaterialCircularProgress = ({ size = 150, value, thickness }: CircularProgressProps) => {
  const classes = useStyles({ size });
  // const actualValue = value - 15;
  // const normalizedValue = Math.min(Math.max(value, 0), 100);
  // console.log('normalizedValue', normalizedValue);

  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // const timer = setInterval(() => {
    //   setProgress(prevProgress => (prevProgress >= 100 ? 0 : prevProgress + 1));
    // }, 5000);

    // return () => {
    //   clearInterval(timer);
    // };
    const updateProgress = () => {
      setProgress(prevProgress => {
        const newProgress = prevProgress >= 100 ? 0 : prevProgress + 1;

        // Determine delay dynamically
        const delay = newProgress > 50 ? 15000 : 5000;

        // Set next update
        setTimeout(updateProgress, delay);

        return newProgress;
      });
    };

    // Initial call
    const timer = setTimeout(updateProgress, 5000);

    return () => clearTimeout(timer);
  }, []);

  const showProgress = Math.floor(progress);

  const actualProgress = Math.floor(value);

  return (
    <div className={classes.container}>
      <CircularProgress
        variant="static"
        className={classes.bottom}
        value={100}
        size={size}
        classes={{
          circle: classes.circle,
        }}
        thickness={thickness}
      />
      <CircularProgress
        variant="static"
        className={classes.top}
        value={value > progress ? value : progress}
        size={size}
        classes={{
          circle: classes.circle,
        }}
        thickness={thickness}
      />
      <Typography variant="body2" className={classes.value}>
        {value > progress ? `${actualProgress}%` : `${showProgress}%`}
      </Typography>
    </div>
  );
};
